<template>
  <div class="box description" :style="{'background-color': color }">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "white",
      required: false,
    }
  }
}
</script>

<style scoped>
.border {
  border: 1px solid #555555;
  border-radius: 2px;
  margin: 1em;
  padding: 1em;
}

.desc-title {
  color: #000;
  font-size: 2rem;
  text-align: center;
  width: 100%; 
}

.description {
  text-align: left;
}

ul {
  list-style: disc;
  padding: 0.3rem 2rem;
}

p {
  margin-bottom: 0.5rem;
}

</style>